/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { TemplateQuoteSubscriptionStatus_QuoteTemplateFragmentDoc } from './TemplateQuoteSubscriptionStatus.generated.js';
import { TemplateQuotePublishingStatus_QuoteTemplateFragmentDoc } from './TemplateQuotePublishingStatus.generated.js';
export type TemplateQuoteStatuses_QuoteTemplateFragment = { __typename: 'QuoteTemplate', id: string, owningSystemOrganisationId: string, hasAnyPublishedVersion: boolean, accessType: Types.TemplateAccessType, resolvedAsReadModelVersionNumber?: number | null, templateSharing?: { __typename: 'TemplateSharing', id: string, latestSharedVersionNumber: number, sharedPublicly: boolean, subscribedToTemplate?: { __typename: 'TemplateSubscription', subscribedVersionNumber: number, updateAvailable: boolean } | null } | null };

export const TemplateQuoteStatuses_QuoteTemplateFragmentDoc = gql`
    fragment TemplateQuoteStatuses_QuoteTemplate on QuoteTemplate {
  id
  owningSystemOrganisationId
  hasAnyPublishedVersion
  accessType
  ...TemplateQuoteSubscriptionStatus_QuoteTemplate
  ...TemplateQuotePublishingStatus_QuoteTemplate
}
    ${TemplateQuoteSubscriptionStatus_QuoteTemplateFragmentDoc}
${TemplateQuotePublishingStatus_QuoteTemplateFragmentDoc}`;